import { Input, Modal } from 'antd'
import { FC, useEffect, useState } from 'react'

interface ConfirmationModalProps {
  isVisible: boolean
  isSubmitting: boolean
  onConfirm: () => void
  onCancel: () => void
}

export const ConfirmationModal: FC<ConfirmationModalProps> = ({
  isVisible,
  isSubmitting,
  onConfirm,
  onCancel,
}) => {
  const [acknowledgmentText, setAcknowledgmentText] = useState('')

  // Reset acknowledgment text when modal opens/closes
  useEffect(() => {
    if (!isVisible) {
      setAcknowledgmentText('')
    }
  }, [isVisible])

  return (
    <Modal
      title='Are you sure you want to update these entries?'
      open={isVisible}
      onOk={onConfirm}
      onCancel={onCancel}
      okText='Yes, update entries'
      cancelText='Cancel'
      okType='danger'
      okButtonProps={{
        disabled: acknowledgmentText !== 'I acknowledge',
      }}
      confirmLoading={isSubmitting}>
      <div>
        <p>
          This action is <b>irreversible</b> and will update all selected
          entries.
        </p>
        <ul>
          <li>These changes cannot be undone.</li>
          <li>Ensure you have reviewed all changes before proceeding.</li>
        </ul>
        <div style={{ marginTop: '1rem' }}>
          <p>
            To confirm this action, please type{' '}
            <strong>&quot;I acknowledge&quot;</strong> below:
          </p>
          <Input
            value={acknowledgmentText}
            onChange={(e) => setAcknowledgmentText(e.target.value)}
            placeholder='Type "I acknowledge" to confirm'
            style={{ marginTop: '0.5rem' }}
          />
        </div>
      </div>
    </Modal>
  )
}
